var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCollectionRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 55,
    viewBox: "0 0 28 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9998_1021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6063 48.8528L1.6059 48.8532C0.531595 50.0783 0.530989 52.058 1.60635 53.2759C2.69486 54.5087 4.48979 54.5071 5.59101 53.2769L5.59191 53.2759L26.3919 29.7195C26.9207 29.1206 27.2 28.332 27.2 27.5C27.2 26.6679 26.9207 25.8794 26.3919 25.2805L5.59192 1.72411L5.59056 1.7226C4.48273 0.493385 2.69513 0.491051 1.60634 1.72411L1.60501 1.72564C0.532335 2.96561 0.530542 4.94466 1.60635 6.16303L20.4466 27.5L1.6063 48.8528Z",
    fill: "#535355",
    stroke: "#535355",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9998_1021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCollectionRightChevron);
export default __webpack_public_path__ + "static/media/edit-collection-right-chevron.84b50df0cf1dd30b343bbd66666d7142.svg";
export { ForwardRef as ReactComponent };